import { IInstrumentViewData } from "../instrument/InstrumentViewData";


export default interface IStationFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    name: string;
    description: string;
    instruments: IInstrumentViewData[];
}

export class StationFormData implements IStationFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    name: string;
    description: string;
    instruments: IInstrumentViewData[];

    constructor(isEditMode: boolean, requestId: string, id: string, name: string, descriptions: string, instruments: IInstrumentViewData[]) {

        this.isEditMode = isEditMode;
        this.requestId = requestId;
        this.id = id;
        this.name = name;
        this.description = descriptions;
        this.instruments = instruments;
    }
}


const defaultStationFormData = new StationFormData(false, "", "", "","",[]);
export { defaultStationFormData };